import { useMemo } from 'react';
import { setPaginationRange } from './Pagination.helpers';
const MINIMAL_ITEMS_NUMBER = 5;
export var Dots;
(function (Dots) {
    Dots["LEFT"] = "left-dots";
    Dots["RIGHT"] = "right-dots";
})(Dots || (Dots = {}));
const usePagination = ({ totalPages, siblingsNumber = 1, currentPage }) => {
    const paginationRange = useMemo(() => {
        const totalPagesNumber = siblingsNumber + MINIMAL_ITEMS_NUMBER;
        if (totalPagesNumber >= totalPages) {
            return setPaginationRange(1, totalPages);
        }
        const leftSiblingIndex = Math.max(currentPage - siblingsNumber, 1);
        const rightSiblingIndex = Math.min(currentPage + siblingsNumber, totalPages);
        const shouldShowLeftDots = leftSiblingIndex > 2;
        const shouldShowRightDots = rightSiblingIndex < totalPages - 2;
        const firstPageIndex = 1;
        const lastPageIndex = totalPages;
        if (!shouldShowLeftDots && shouldShowRightDots) {
            const leftItemIndex = 3 + 2 * siblingsNumber;
            const leftRange = setPaginationRange(1, leftItemIndex);
            return [...leftRange, Dots.RIGHT, totalPages];
        }
        if (shouldShowLeftDots && !shouldShowRightDots) {
            const rightItemIndex = 3 + 2 * siblingsNumber;
            const rightRange = setPaginationRange(totalPages - rightItemIndex + 1, totalPages);
            return [firstPageIndex, Dots.LEFT, ...rightRange];
        }
        if (shouldShowLeftDots && shouldShowRightDots) {
            const middleRange = setPaginationRange(leftSiblingIndex, rightSiblingIndex);
            return [firstPageIndex, Dots.LEFT, ...middleRange, Dots.RIGHT, lastPageIndex];
        }
        return [];
    }, [siblingsNumber, totalPages, currentPage]);
    return paginationRange;
};
export default usePagination;
//# sourceMappingURL=usePagination.js.map